import { render } from "./ImageSliderCreatePageHeader.vue?vue&type=template&id=5155dec8"
import script from "./ImageSliderCreatePageHeader.vue?vue&type=script&lang=js"
export * from "./ImageSliderCreatePageHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/abiinteriors/Documents/WorkSpace/abi-content-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__